<template>
    <!-- {{ item }} -->
    <div class="px-1.5 py-3 rounded-[10px] border-[1px] border-[#CCCCCC] bg-white cursor-pointer">
        <!-- bundle header -->
        <div class="mobile:block laptop:flex items-center !justify-between !w-full px-2.5">
            <div>
                <div class="flex justify-start items-center gap-1">
                    <div class="w-1.5 h-1.5 rounded-full bg-blueLight-100"></div>
                    <div class="w-6 h-1.5 rounded-full bg-blueLight-100"></div>
                    <p class="mobile:text-[18px] laptop:text-[20px] font-semibold font-roboto pl-2 m-0 text-blueLight-100">New Bundle</p>
                </div>
                <div>
                    <h2
                    class="mobile:my-2 table:m-0 mobile:text-[18px] desktop:text-[22px] text-[#333333] font-roboto font-medium">
                    {{ item.plan_name }}</h2>
                </div>
            </div>
            <div class="text-left laptop:py-0 mobile:py-[10px]">
                <h6 class="m-0 font-roboto font-medium mobile:text-[16px] laptop:text-[18px] text-[#EA8A8A]">{{ item.months ?? '12 months plan' }}</h6>
                <h2 class="m-0 mobile:text-[22px] desktop:text-[30px] text-[#333333] font-roboto font-bold">${{ $helper.formatAmount(item.total_amount)
                }}<span
                    class="font-medium mobile:text-[14px] desktop:text-[18px]">/mo</span></h2>
            </div>
        </div>
        <!-- bundle body -->
        <div class="flex flex-wrap">
            <div v-for="(bundle, index) in JSON.parse(item.description)" :key="index" class="flex-1 mobile:py-1.5 mobile:px-2.5 tablet:py-2.5 tablet:px-2.5 mobile:min-w-[100%] tablet:min-w-[50%] laptop:min-w-[33.33%] largeDesktop:min-w-[25%]">
                
                <div class="p-3 mobile:min-h-[unset] flex flex-col justify-start gap-2 rounded-xl bg-[#F1F1F180]"
                :class='JSON.parse(item.description).length == 2 ? "tablet:min-h-20" : "tablet:min-h-28"'>
                    <div class="py-0.5 px-[12px] text-xs font-roboto w-fit rounded-full shadow-[0px_0px_10px_0px_#00000026;] bg-white text-purple-100">{{ bundle.trade_name }}</div>
                    <h4 class="text-base font-normal font-roboto mb-0 text-black-100">{{ bundle.plan_name }}</h4>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {

    props: ["item"],

    data() {
        return {
        
        };
    },
    components: {
     
    },
    computed: {
    
    },
    watch: {

      
    },
    mounted() {
    },
    beforeUnmount() {
    },
    methods: {
     

     
    }
}

</script>
